import { render } from "./ReservationFilter.vue?vue&type=template&id=06062c24"
import script from "./ReservationFilter.vue?vue&type=script&lang=js"
export * from "./ReservationFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__